export const CustomerData = [
  {
    cardHeight: "490px",
    imgbgUrl: "//files.authing.co/authing-website/customer-story-hep-bg.png",
    imgUrl: "//files.authing.co/authing-website/home-logo-higer-new.png",
    cardQuote: "customer.home.cardList.item1.text",
    url: "/customer/hep",
  },
  {
    cardHeight: "450px",
    imgbgUrl: "//files.authing.co/authing-website/customer-story-yuanqi-bg.png",
    imgUrl: "//files.authing.co/authing-website/home-logo-yuanqi-forest.png",
    cardQuote: "customer.home.cardList.item2.text",
    url: "/customer/yuanqi",
  },
  {
    cardHeight: "450px",
    imgbgUrl: "//files.authing.co/authing-website/customer-story-cnpn-bg.png",
    imgUrl: "//files.authing.co/authing-website/home-logo-cnpc-new.png",
    cardQuote: "customer.home.cardList.item3.text",

    url: "/customer/cnpn",
  },
  {
    cardHeight: "400px",
    imgbgUrl:
      "//files.authing.co/authing-website/customer-story-southeast-bg.png",
    imgUrl: "//files.authing.co/authing-website/home-logo-dongnan-new.png",
    cardQuote: "customer.home.cardList.item4.text",
    url: "/customer/southeast-university",
  },
  {
    cardHeight: "340px",
    imgbgUrl:
      "//files.authing.co/authing-website/customer-story-volkswagen-bg.png",
    imgUrl: "//files.authing.co/authing-website/vw.png",
    cardQuote: "customer.home.cardList.item5.text",
    url: "/customer/volkswagen",
  },
  {
    cardHeight: "380px",
    imgbgUrl:
      "//files.authing.co/authing-website/customer-story-bentleymotor-bg.png",
    imgUrl: "//files.authing.co/authing-website/bentleymotors.png",
    cardQuote: "customer.home.cardList.item6.text",

    url: "/customer/bentley-motors",
  },
  {
    cardHeight: "400px",
    imgbgUrl: "//files.authing.co/authing-website/customer-story-toyota-bg.png",
    imgUrl: "//files.authing.co/authing-website/brand-toyota-red.svg",
    cardQuote: "customer.home.cardList.item7.text",
    url: "/customer/toyota",
  },
  {
    cardHeight: "380px",
    imgbgUrl:
      "//files.authing.co/authing-website/customer-story-jcdecaux-bg.png",
    imgUrl: "//files.authing.co/authing-website/brand-logo-jcdecaux.png",
    cardQuote: "customer.home.cardList.item8.text",
    url: "/customer/jcdecaux",
  },
  {
    cardHeight: "480px",
    imgbgUrl: "//files.authing.co/authing-website/customer-story-bosch-bg.png",
    imgUrl: "//files.authing.co/authing-website/customer-logo-bosch.png",
    cardQuote: "customer.home.cardList.item9.text",
    url: "/customer/bosch",
  },
  {
    cardHeight: "380px",
    imgbgUrl:
      "//files.authing.co/authing-website/customer-story-pingcap-bg.png",
    imgUrl: "//files.authing.co/authing-website/home-logo-pingcap.png",
    cardQuote: "customer.home.cardList.item10.text",
    url: "/customer/pingcap",
  },
  {
    cardHeight: "480px",
    imgbgUrl: "//files.authing.co/authing-website/customer-story-huaxi-bg.png",
    imgUrl: "//files.authing.co/authing-website/logo-sichuan-university.png",
    cardQuote: "customer.home.cardList.item11.text",
    url: "/customer/west-china-hospital",
  },
  {
    cardHeight: "380px",
    imgbgUrl:
      "//files.authing.co/authing-website/customer-story-bentley-bg-v2.png",
    imgUrl: "//files.authing.co/authing-website/brand-bentley.png",
    cardQuote: "customer.home.cardList.item12.text",
    url: "/customer/bentley",
  },
];
